// BillingItem.jsx
import React, { useState } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useFormatos } from "../../../i18n/formatos";
import { ModalUploadProvider } from "./ModalUploadProvider"; // Nuevo modal para subir fact. proveedor

export function BillingItem(props) {
  const { billing, isPartner } = props;
  // El comun ya trae "Descargar" y "Subir": aqui solo viven los textos propios
  // de facturacion.
  const { t } = useTranslation(["ui", "common"]);
  const { fechaLarga } = useFormatos();
  const billingObj = billing.billings || {};
  const userObj = billingObj.user || {};

  // Para abrir/cerrar el modal de subir Factura Proveedor
  const [showModalUpload, setShowModalUpload] = useState(false);

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  // Factura Cliente: sólo descarga
  const renderFacturaCliente = () => {
    if (!billingObj.billingdata) {
      return <span>{t("facturacion.item.noDisponible")}</span>;
    } else {
      return (
        <Button
          size="mini"
          onClick={() => handleDownload(billingObj.billingdata)}
          title={t("facturacion.item.descargarFacturaCliente")}
        >
          <Icon name="download" />
          {t("common:actions.download")}
        </Button>
      );
    }
  };

  // Factura Proveedor: solo partner la ve
  const renderFacturaProveedor = () => {
    if (!isPartner) return null;

    if (!billingObj.billingdatapartner) {
      // No hay => "No disponible" + Botón “Subir”
      return (
        <>
          <span>{t("facturacion.item.noDisponible")}</span>{" "}
          <Button
            size="mini"
            onClick={() => setShowModalUpload(true)}
            title={t("facturacion.item.subirFacturaProveedor")}
          >
            <Icon name="upload" /> {t("common:actions.upload")}
          </Button>
        </>
      );
    } else {
      // Hay => "Descargar" + Botón “Reemplazar”
      return (
        <>
          <Button
            size="mini"
            onClick={() => handleDownload(billingObj.billingdatapartner)}
            title={t("facturacion.item.descargarFacturaProveedor")}
          >
            <Icon name="download" />
            {t("common:actions.download")}
          </Button>{" "}
          <Button
            size="mini"
            onClick={() => setShowModalUpload(true)}
            title={t("facturacion.item.reemplazarFacturaProveedor")}
          >
            <Icon name="upload" /> {t("common:actions.upload")}
          </Button>
        </>
      );
    }
  };

  // Fecha larga ("8 ago 2026" / "8 août 2026"). Antes llevaba "es-ES" clavado,
  // asi que en frances seguia saliendo el mes en espanol.
  const dateFormatted = billingObj.created_at
    ? fechaLarga(billingObj.created_at)
    : t("facturacion.item.sinDato");

  return (
    <>
      <Table.Row>
        <Table.Cell>{userObj.role || t("facturacion.item.sinDato")}</Table.Cell>
        <Table.Cell>
          {userObj.firstname} {userObj.lastname}
        </Table.Cell>
        <Table.Cell>{billingObj.billingNumber}</Table.Cell>
        <Table.Cell>{billingObj.description}</Table.Cell>
        <Table.Cell>{billingObj.billingtotal}</Table.Cell>

        {isPartner && <Table.Cell>{billingObj.billingpartner}</Table.Cell>}

        <Table.Cell>{billingObj.status}</Table.Cell>

        <Table.Cell>{renderFacturaCliente()}</Table.Cell>

        {isPartner && <Table.Cell>{renderFacturaProveedor()}</Table.Cell>}

        <Table.Cell>{dateFormatted}</Table.Cell>
      </Table.Row>

      {/* Modal para Subir Factura Proveedor */}
      {isPartner && (
        <ModalUploadProvider
          show={showModalUpload}
          onClose={() => setShowModalUpload(false)}
          billing={billing}
        />
      )}
    </>
  );
}
